import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpResponse,
  HttpEvent
} from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { LoadingService } from './loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {    
   
   
    if (request.method == "POST" || request.method == "PUT"){ 
        this.totalRequests++;
        this.loadingService.setLoading(true);
    }

    return next.handle(request).pipe(
      finalize( () => {
        if (request.method == "POST" || request.method == "PUT") this.totalRequests--;
        if (this.totalRequests === 0) {
          this.loadingService.setLoading(false);
        }
      })
    );
  }
}